import { ICarReviewLink } from 'app/apiCalls/kentico';
import Translation from 'app/shared/components/Translation/Translation';
import { TitleSt } from 'app/shared/components/ModelReview/OtherModelsReviews/OtherModelsReviews.css';
import { ReviewLink } from 'app/shared/components/ModelReview/OtherModelsReviews/ReviewLink';

export interface IOtherModelsReviewsProps {
  popularModels: ICarReviewLink[];
}

export const OtherModelsReviews = ({
  popularModels,
}: IOtherModelsReviewsProps) => {
  return popularModels.length === 0 ? null : (
    <>
      <TitleSt>
        <Translation
          id="shared.components.reviews.popularModels"
          defaultMessage="Popular Models"
        />
      </TitleSt>
      {popularModels.map(pM => (
        <ReviewLink key={pM.slug} reviewLink={pM} />
      ))}
    </>
  );
};
